/* unplugin-vue-components disabled */import script from "./UploadPicture.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadPicture.vue?vue&type=script&setup=true&lang=js"

import "./UploadPicture.vue?vue&type=style&index=0&id=a2e38736&lang=scss"

const __exports__ = script;

export default __exports__